export default "__VITE_ASSET__BHpSeyPF__"